import { ReactNode, useState } from "react";
import { clsx } from "clsx";

interface AccordionProps {
  children: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  size?: "large";
  hideExpandedUnderline?: boolean;
  iconSide?: "left" | "right";
  insetContent?: boolean;
  tagName?: "h2" | "h3" | "h4" | "h5" | "h6";
  initiallyExpanded: boolean;
}

export default function Accordion({
  children,
  title,
  subtitle,
  size,
  hideExpandedUnderline,
  iconSide = "left",
  insetContent,
  tagName: TagName = "h3",
  initiallyExpanded,
}: AccordionProps) {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

  return (
    <>
      <TagName
        className={clsx(
          "vst-accordion",
          size && `vst-accordion-size-${size}`,
          hideExpandedUnderline &&
            "vst-accordion-option-hide-expanded-underline",
          iconSide === "right" && "vst-accordion-option-icon-right"
        )}
      >
        <button
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((expanded) => !expanded)}
          type="button"
        >
          {title}
          {subtitle && (
            <span className="vst-accordion-subtext">{subtitle}</span>
          )}
        </button>
      </TagName>
      <div
        className={clsx(
          "vst-accordion-content",
          insetContent && "vst-accordion-content-inset"
        )}
      >
        {children}
      </div>
    </>
  );
}
